import PortalClienteService from "services/bases/PortalClienteService";

class ListasPrecoService extends PortalClienteService {
    async ListarPlanosPorDireito(tenantId, direitoId, modeloDeOfertaCodigo) {
        let url = `ListasDePrecos/ListarPlanosPorDireito?modeloDeOfertaCodigo=${modeloDeOfertaCodigo}&direitoId=${direitoId}&tenantId=${tenantId}`;
        return await this.get(url);
    }
    async ListarLicencasAdicionaisPorDireito(tenantId, direitoId, modeloDeOfertaCodigo) {
        let url = `ListasDePrecos/ListarLicencasAdicionaisPorDireito?modeloDeOfertaCodigo=${modeloDeOfertaCodigo}&direitoId=${direitoId}&tenantId=${tenantId}`;
        return await this.get(url)
    }
    async ListarProdutosPorLicencaAtribuida(tenantId, direitoId, modeloDeOfertaCodigo, licencas) {
        let url = `ListasDePrecos/ListarProdutosPorLicencaAtribuida?modeloDeOfertaCodigo=${modeloDeOfertaCodigo}&direitoId=${direitoId}&tenantId=${tenantId}`;
        return await this.post(url, licencas)
    }
}

export default new ListasPrecoService();